<template>
  <v-alert
    v-if="needsScheduling || (client && dataSource)"
    :color="alertType"
    transition="scale-transition"
    prominent
  >
    <v-row align="center">
      <v-col class="col-7" v-if="alertType === 'error'">
        <h3 class="headline">Schedule a run!</h3>
        <p>
          Looks like this resource is not scheduled to run. Kick it into action
          by setting the modified since for the next run. The next run will be
          ran as soon as you submit.
        </p>
      </v-col>
      <v-col :class="getColSize()">
        <v-text-field
          outlined
          v-model="modifiedSince"
          clear-icon="mdi-close-circle"
          label="Modified since"
          type="datetime-local"
          :disabled="$store.state.scheduling"
          :max="maxModifiedSinceTime"
        />
        <v-text-field
          outlined
          v-if="showModifiedUntil"
          v-model="modifiedUntil"
          clear-icon="mdi-close-circle"
          label="Modified until"
          type="datetime-local"
          :disabled="!modifiedSince"
          :max="maxModifiedSinceTime"
          :min="modifiedSince"
        />
        <v-btn
          class="col-12"
          large
          outlined
          :disabled="!modifiedSince || $store.state.scheduling"
          :loading="$store.state.scheduling"
          v-on:click="schedule"
          >{{ submitButtonLabel }}</v-btn
        >
      </v-col>
    </v-row>
  </v-alert>
</template>

<script>
import moment from 'moment';
import { eventBus } from '../main';

export default {
  props: {
    submitButtonLabel: { type: String, default: 'Submit' },
    status: { type: Object },
    scheduled: { type: Array },
    resourceType: { type: String },
    alertType: { type: String, default: 'error' },
    client: { type: String, default: '' },
    dataSource: { type: String, default: '' },
    showModifiedUntil: { type: Boolean, default: false },
    disableScheduling: { type: Boolean, default: false },
  },
  data() {
    return {
      scheduling: false,
      modifiedSince: null,
      modifiedUntil: null,
    };
  },
  methods: {
    getColSize() {
      return this.alertType === 'error' ? 'col-5' : 'col-12';
    },
    schedule() {
      this.$store.dispatch('schedule', {
        resourceType: this.resourceType,
        modifiedSince: this.modifiedSince,
        modifiedUntil: this.modifiedUntil,
        client: this.client,
        dataSource: this.dataSource,
        disableScheduling: this.disableScheduling,
      });
    },
  },
  computed: {
    needsScheduling() {
      return (
        this.status &&
        this.status.status !== 'Running' &&
        (!this.scheduled ||
          !this.scheduled.length ||
          this.scheduled.some(schedule => !schedule.time))
      );
    },
    maxModifiedSinceTime() {
      return moment().format('YYYY-MM-DDTHH:mm:ss');
    },
  },
};
</script>
